// Shop colors (Settings → Look & colors). Each theme sets the sidebar, the main buttons and the accent (Create button).
// "light" themes get a white sidebar with dark text.
export type Theme = { label: string; navy: string; navy2: string; steel: string; steel2: string; accent: string; light?: boolean; onSteel?: string; link?: string };
export const THEMES: Record<string, Theme> = {
  blue: { label: 'Classic blue', navy: '#16263a', navy2: '#1f3550', steel: '#285a89', steel2: '#1f4a72', accent: '#F59E0B' },
  darkblue: { label: 'Dark blue', navy: '#0a1222', navy2: '#132240', steel: '#1d4ed8', steel2: '#1e40af', accent: '#60a5fa' },
  light: { label: 'Light blue', navy: '#ffffff', navy2: '#f3f7fc', steel: '#2563eb', steel2: '#1d4ed8', accent: '#2563eb', light: true },
  gold: { label: 'Gold', navy: '#2a1e06', navy2: '#4a360c', steel: '#e0b23a', steel2: '#c99a22', accent: '#f5c542', onSteel: '#2a1e06', link: '#8a6100' },
  burgundy: { label: 'Burgundy', navy: '#2a0e12', navy2: '#3d151b', steel: '#9f1239', steel2: '#881337', accent: '#ef4444' },
  red: { label: 'Red', navy: '#1c1917', navy2: '#2a2321', steel: '#b91c1c', steel2: '#991b1b', accent: '#ef4444' },
};
export const THEME_KEYS = Object.keys(THEMES);
export const isLightTheme = (name?: string) => !!THEMES[name || 'blue']?.light;
export function applyTheme(name?: string) {
  const t = THEMES[name || 'blue'] || THEMES.blue;
  const r = document.documentElement;
  r.style.setProperty('--navy', t.navy); r.style.setProperty('--navy-2', t.navy2);
  r.style.setProperty('--steel', t.steel); r.style.setProperty('--steel-2', t.steel2); r.style.setProperty('--accent', t.accent);
  r.style.setProperty('--on-steel', t.onSteel || '#fff');
  r.style.setProperty('--link', t.link || t.steel);
  r.dataset.side = t.light ? 'light' : 'dark';
}
